// extracted by mini-css-extract-plugin
module.exports = {"content":"text_content__29fCX","border":"text_border__1j0lz"};